import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-4" }

import { useI18n } from 'vue-i18n'
import { computed, ref } from 'vue'
import { Applicant, Message, RequestResponse } from '@/types'

import { onMounted } from 'vue'

import { broadcastingActions } from '@/stores/broadcasting-store'
import MessageTable from '@/components/Static/MessageTable/MessageTable.vue'
import { Delta } from '@vueup/vue-quill'
import MessageBox from '@/components/Static/MessageBox/MessageBox.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'StudentMessages',
  emits: ['read'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const emit = __emit
const broadcasting = broadcastingActions()
const page = ref(1)
const itemsPerPage = ref(5)
const requestResponse = ref<RequestResponse>()
const seenRequestResponse = ref<RequestResponse>()
const loading = ref(false)
const messages = ref<Message[]>([])
const view = ref(false)
const id = ref<string>('')
const content = ref<Delta>()
const title = ref<string>('')
const doctorName = ref<string>('')
const doctorProfile = ref<string>('')
const token = localStorage.getItem('accessToken') ?? ''
onMounted(() => {
  getMessages()
})

const getMessages = async () => {
  loading.value = true

  const response = await broadcasting.getMessages(
    page.value,
    itemsPerPage.value,
    token
  )
  requestResponse.value = response
  if (response.success) {
    messages.value = response.result as Message[]
  }
  loading.value = false
}

const viewMessage = async (event: any) => {
  id.value = event.id
  title.value = event.title
  content.value = event.content
  doctorName.value = event.name
  doctorProfile.value = event.photo

  view.value = true

  const response = await broadcasting.markSeen(token, id.value)
  seenRequestResponse.value = response
  if (response.success) {
    emit('read')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_request_status = _resolveComponent("request-status")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('your-messages')), 1),
    _createVNode(_component_v_divider, { class: "mt-3" }),
    _createVNode(_component_request_status, {
      response: requestResponse.value,
      isLoading: loading.value
    }, null, 8, ["response", "isLoading"]),
    _createVNode(_component_request_status, {
      response: seenRequestResponse.value,
      isLoading: false
    }, null, 8, ["response"]),
    (!loading.value)
      ? (_openBlock(), _createBlock(MessageTable, {
          key: 0,
          messages: messages.value,
          isDoctor: false,
          onView: _cache[0] || (_cache[0] = ($event: any) => (viewMessage($event)))
        }, null, 8, ["messages"]))
      : _createCommentVNode("", true),
    (view.value)
      ? (_openBlock(), _createBlock(MessageBox, {
          key: 1,
          content: content.value,
          title: title.value,
          broadcast: view.value,
          editView: false,
          studentView: true,
          doctorName: doctorName.value,
          doctorProfile: doctorProfile.value,
          modelValue: view.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((view).value = $event)),
          onCloseDialog: _cache[2] || (_cache[2] = ($event: any) => (view.value = false))
        }, null, 8, ["content", "title", "broadcast", "doctorName", "doctorProfile", "modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})